import { Helmet } from 'react-helmet';
import { useI18n } from '@hooks/useI18n/useI18n';

export const AppLanguageController = () => {
  const { selectedLanguage } = useI18n();

  return <Helmet htmlAttributes={{ lang: selectedLanguage }} />;
};
